"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTooltipSettings = void 0;
const get_internal_is_tooltip_visible_1 = require("./get_internal_is_tooltip_visible");
const get_settings_spec_1 = require("./get_settings_spec");
const get_tooltip_spec_1 = require("./get_tooltip_spec");
const create_selector_1 = require("../create_selector");
const getChartId = ({ chartId }) => chartId;
const getTooltipSettingsSingleton = (0, create_selector_1.createCustomCachedSelector)([getChartId], () => ({}));
exports.getTooltipSettings = (0, create_selector_1.createCustomCachedSelector)([getTooltipSettingsSingleton, get_tooltip_spec_1.getTooltipSpecSelector, get_settings_spec_1.getSettingsSpecSelector, get_internal_is_tooltip_visible_1.getInternalIsTooltipVisibleSelector], (settingsBase, tooltip, { externalPointerEvents }, { isExternal }) => {
    if (!isExternal)
        return tooltip;
    return Object.assign(settingsBase, {
        ...tooltip,
        ...externalPointerEvents.tooltip,
    });
});
//# sourceMappingURL=get_tooltip_settings.js.map